/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 9/24/2020
 */

function LoginEditServiceConstructor (
    this: JS5Object,
    $location: JS5Object,
    Rx: JS5Object,
    SidebarService: JS5Object,
) {
    this.errorObservable = new Rx.BehaviorSubject({});

    this.setError = (errorName: string, displayText: string) => {
        this.errorObservable.value[errorName] = displayText;
        this.errorObservable.onNext(this.errorObservable.value);
    };

    this.removeError = (errorName: string) => {
        delete this.errorObservable.value[errorName];
        this.errorObservable.onNext(this.errorObservable.value);
    };

    this.navigateToApp = () => {
        SidebarService.clearSessionData();
        if (localStorage.preLoginRoute) {
            $location.url(localStorage.preLoginRoute);
            localStorage.removeItem('preLoginRoute');
        } else {
            $location.path('/packages');
        }
    }
}

angular
    .module('prism-ui.login')
    .service(
        'LoginEditService',
        LoginEditServiceConstructor
    );
